import { h } from 'preact';
import { Link } from 'react-router-dom';
import format from 'date-fns/format';
import definition from '../pdf/pdfDefinition';
import formatMoney from '../utils/formatMoney';
const InvoiceItem = ({ desc, price, qty = '', count }) => {
    return (h("div", { className: "row invoice__row" },
        h("div", { className: "col-md-1" }, count),
        h("div", { className: "col-md-7" }, desc),
        h("div", { className: "col-md-1" }, qty),
        h("div", { className: "col-md-3" }, formatMoney(price))));
};
const openPDF = ({ _id, name, email, phone, date, totalPrice, items, address1, address2, invoiceType, companyName, license, companyAddress, companyAddress2, companyEmail, companyPhone, projectName, displayId }) => () => {
    pdfMake.createPdf(definition({
        _id: displayId || _id,
        name,
        email,
        phone,
        date: format(date, 'MM/DD/YYYY'),
        totalPrice,
        address1,
        address2,
        companyEmail,
        companyAddress,
        companyAddress2,
        companyPhone,
        items,
        invoiceType: invoiceType.toUpperCase(),
        companyName,
        license,
        projectName
    })).open();
};
const ProjectName = ({ title }) => {
    return (h("div", { className: "info__row" },
        h("b", null, "Project Name:"),
        h("div", { style: "margin-top:5px;" }, title)));
};
const Invoice = ({ _id, customer, date, items, title, total, type, onDelete, company = {}, displayId }) => {
    const border = [true, true, true, true];
    const margin = [2, 2, 2, 2];
    const address2 = customer.city && customer.state
        ? `${customer.city}, ${customer.state.toUpperCase()}. ${customer.zip ||
            ""}`
        : "";
    const companyAddress2 = company && company.city && company.state && company.zip
        ? `${company.city}, ${company.state.toUpperCase()}. ${company.zip}`
        : "";
    const pdf = openPDF({
        _id,
        displayId,
        invoiceType: type,
        name: `${customer.name.first} ${customer.name.last}`,
        email: customer.email,
        phone: customer.phone ? customer.phone : "",
        projectName: title,
        address1: customer.address,
        address2,
        companyAddress: company && company.address,
        companyAddress2,
        companyEmail: company && company.email,
        date,
        totalPrice: formatMoney(total),
        items: items.map(({ desc, qty, price }) => [
            { text: desc, margin, border },
            { text: qty || "", margin, border },
            { text: formatMoney(price) ? formatMoney(price) : "", margin, border }
        ]),
        companyName: company.name || "",
        license: company.license || "",
        companyPhone: (company && company.phone) || ""
    });
    return (h("div", null,
        h("div", { className: "top-nav-header clearfix" },
            h("div", { className: "left" },
                h("button", { className: "btn btn--secondary", onClick: pdf }, "Open PDF")),
            h("div", { className: "right" },
                h("div", { class: "columns" },
                    h("div", { className: "btn-stack" },
                        h(Link, { className: "btn btn--left", to: `/edit/invoice/${_id}` }, "Edit")),
                    h("div", { className: "btn-stack" },
                        h("button", { className: "btn btn--secondary btn--right", onClick: onDelete }, "Delete"))))),
        h("h1", null,
            type,
            " # ",
            _id),
        h("p", null,
            "Display ID : ",
            displayId || "NA"),
        h("time", null,
            "Date: ",
            format(date, "MM/DD/YYYY")),
        h("div", { className: "info" },
            h("p", { className: "info__row" },
                h(Link, { to: `/customer/${customer._id}` },
                    customer.name.first,
                    " ",
                    customer.name.last)),
            h("p", { className: "info__row" }, customer.email),
            h("address", { className: "info__row" },
                customer.address,
                " ",
                h("br", null),
                address2),
            h("p", { className: "info__row" }, customer.phone)),
        title ? h(ProjectName, { title: title }) : null,
        h("div", null,
            h("h2", null, "Invoice Details"),
            h("div", { className: "row invoice__row" },
                h("div", { className: "col-md-1 bold" }, "No."),
                h("div", { className: "col-md-7 bold" }, "Item Description"),
                h("div", { className: "col-md-1 bold" }, "QTY"),
                h("div", { className: "col-md-3 bold" }, "Price")),
            items.map((item, index) => h(InvoiceItem, { ...item, count: index + 1 })),
            h("div", { className: "row invoice__row" },
                h("div", { className: "col-md-1" }),
                h("div", { className: "col-md-7" }),
                h("div", { className: "col-md-1" }),
                h("div", { className: "col-md-3 " },
                    h("b", null, "Total:"),
                    " ",
                    formatMoney(total))))));
};
export default Invoice;
